import { render, staticRenderFns } from "./DomoFooter.vue?vue&type=template&id=68d28c64&scoped=true&"
import script from "./DomoFooter.vue?vue&type=script&lang=js&"
export * from "./DomoFooter.vue?vue&type=script&lang=js&"
import style0 from "./DomoFooter.vue?vue&type=style&index=0&id=68d28c64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d28c64",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDivider,VFooter,VImg,VRow})
